import { LitElement, html, css } from 'lit';
import { WEB_CONTENT } from '../../../constants/content';

class DeleteMessage extends LitElement {
  static get properties() {
    return {
      dialogData: { type: Object },
      onClose: { type: Function },
      isMobile: { type: Boolean, reflect: true },
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
        width: 100%;
      }

      .dialog {
        width: 100%;
        text-align: center;
        position: relative;
      }

      .dialog h2 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 1.25rem;
        color: var(--text-primary-color);
        text-transform: capitalize;
      }

      .dialog-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
        padding: 16px;
      }

      .deleteText {
        background: var(--bg-primary-light);
        color: var(--text-primary-color);
        border: none;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 20px;
        width: fit-content;
        cursor: pointer;
      }

      .deleteText:active {
        transform: scale(0.98);
      }

      @media (max-width: 768px) {
        .dialog-actions {
          align-items: center;
        }

        .deleteText {
          width: 100%;
        }
      }
    `;
}

  constructor() {
    super();
    this.dialogData = {};
    this.onClose = () => { };
    this.isMobile = false;
  }

  render() {
    return html`
      <div class="dialog">
        <h2>${WEB_CONTENT.POPUP_MESSAGES.DELETE_LABEL}</h2>
        <div class='dialog-actions' >
        <span class="deleteText" @click=${this.dialogData.deleteMessageForSelf} > 
          ${WEB_CONTENT.MESSAGE_ACTIONS.DELETE_FOR_SELF}
        </span>
        ${this.dialogData.isSelf ? html` <span class="deleteText" @click=${this.dialogData.deleteMessageForEveryone} >
           ${WEB_CONTENT.MESSAGE_ACTIONS.DELETE_FOR_EVERYONE}
            </span>`:null}
          <span class="deleteText" @click=${this.onClose} >${WEB_CONTENT.CONSENT_MESSAGES.CANCEL}</span>
        </div>
      </div>
    `;
  }
}

customElements.define('delete-message', DeleteMessage);
export { DeleteMessage };
